<div class="spinner" *ngIf="isVisible">
  <div class="rect rect1"></div>
  <div class="rect rect2"></div>
  <div class="rect rect3"></div>
  <div class="rect rect4"></div>
  <div class="rect rect5"></div>
</div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/loading-indicator/loading-indicator.component.ts.LoadingIndicatorComponent.html